export const leftTooltipPositionHandler = (labelElement) => {
    const tooltipIconWidth = 8; // in px
    const labelWidth = labelElement.getBoundingClientRect().width;

    return labelWidth - tooltipIconWidth;
};